import React, { useState, useEffect } from "react";
import image from "../../../rels_assets/images/blog/b-11.jpg";
import _ from 'lodash';
import { Link } from "react-router-dom";

const ProjectListBlock = (props) => {
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        setProjects(props.property);
    }, [props]);


    return (
        <>
            <div
                className={`agents-grid ${props.columnClass ? props.columnClass : ''}`}

                data-aos="fade-up"
                data-aos-delay="150"
            >
                <Link to={`/project/${projects.id}`}className="text-decoration-none landscapes">
                    <div className="project-single">
                        <div className="project-inner project-head">
                            <div className="homes">
                                {/* <!-- homes img --> */}
                                <span

                                    className="homes-img"
                                    aria-label="discover-properties"
                                >
                                    {projects.building_status &&
                                        <div className="homes-tag button alt featured project-homes-tag">{projects.building_status}</div>}
                                    {projects.featured_project &&
                                        <div className="homes-tag button alt sale">Featured</div>}
                                    {/* <div
                                        className={`homes-tag button alt sale`}
                                    >
                                        {projects.build_type}
                                    </div> */}

                                    <img loading="lazy" src={
                                        projects?.building_images &&
                                            projects.building_images.length > 0
                                            ? projects.building_images[0].image
                                            : image} onError={(e) => (
                                                e.target.onerror = null,
                                                e.target.src = image
                                            )
                                            }
                                        alt="home-1"
                                        className="img-responsive" />
                                </span>
                            </div>
                            {
                                projects.map_link &&
                                <div className="button-effect pr-2">
                                    <a
                                        href={projects.map_link} target="_blank"
                                        className="btn"
                                        aria-label={`project-${projects.map_link}`}
                                    >
                                        <i className="fa fa-link"></i>
                                    </a>
                                    {/* <OverlayTrigger trigger='click' placement="auto-end" overlay={popover} rootClose>
                                        <Button variant="secondary"><i className="fa fa-link"></i></Button>
                                    </OverlayTrigger> */}
                                </div>
                            }

                        </div>
                        {/* <!-- homes content --> */}
                        <div className="homes-content homes-address">
                            {/* <!-- homes address --> */}
                            <h3>
                                <span aria-label={projects.name} className="text-dark">{projects.name}</span>
                            </h3>
                            {projects.partners && typeof projects.partners === 'object' && Object.keys(projects.partners).length > 0 &&
                                <span className="text-truncate mb-1" title={_.join(_.map(projects.partners), " & ")}>By {_.join(_.map(projects.partners), " & ")}</span>}
                            {projects.building_area &&
                                <div className="homes-address">
                                    <h3 className="text-truncate" title={projects.building_area}>
                                        <span aria-label={projects.building_area}>
                                            <i className="fa fa-map-marker"></i>
                                            <span> {projects.building_area}</span>
                                        </span>
                                    </h3>
                                </div>}
                        </div>
                    </div>
                </Link>
            </div>
        </>
    );
};

export default ProjectListBlock;
